/**
 * Cross-reference of Nigeria's 6 geopolitical regions + the FCT to
 * their states. Used by the distributor registration flow so a
 * distributor can declare which regions they cover and, drilling in,
 * which specific states.
 *
 * Source: standard 36-states + FCT (Abuja) partitioning, per the
 * table shared with product for the coverage picker.
 *
 * If we ever add other countries with region/state coverage, expose
 * this via a `countryToRegions[countryCode]` map. For now we only
 * ship Nigeria; the Country field defaults to it.
 */
export const NIGERIA_REGIONS = [
  {
    id: 'north-west',
    labelKey: 'auth.register.nigeriaRegions.northWest',
    states: ['Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Sokoto', 'Zamfara'],
  },
  {
    id: 'north-east',
    labelKey: 'auth.register.nigeriaRegions.northEast',
    states: ['Adamawa', 'Bauchi', 'Borno', 'Gombe', 'Taraba', 'Yobe'],
  },
  {
    id: 'north-central',
    labelKey: 'auth.register.nigeriaRegions.northCentral',
    states: ['Benue', 'Kogi', 'Kwara', 'Nasarawa', 'Niger', 'Plateau'],
  },
  {
    id: 'south-west',
    labelKey: 'auth.register.nigeriaRegions.southWest',
    states: ['Ekiti', 'Lagos', 'Ogun', 'Ondo', 'Osun', 'Oyo'],
  },
  {
    id: 'south-east',
    labelKey: 'auth.register.nigeriaRegions.southEast',
    states: ['Abia', 'Anambra', 'Ebonyi', 'Enugu', 'Imo'],
  },
  {
    id: 'south-south',
    labelKey: 'auth.register.nigeriaRegions.southSouth',
    states: ['Akwa Ibom', 'Bayelsa', 'Cross River', 'Delta', 'Edo', 'Rivers'],
  },
  {
    id: 'fct',
    labelKey: 'auth.register.nigeriaRegions.fct',
    states: ['Abuja'],
  },
];

// Fast lookup helpers used by the register page.
const REGION_BY_ID = new Map(NIGERIA_REGIONS.map((r) => [r.id, r]));

export function statesForRegions(regionIds) {
  const seen = new Set();
  const out = [];
  for (const id of regionIds) {
    const region = REGION_BY_ID.get(id);
    if (!region) continue;
    for (const state of region.states) {
      if (!seen.has(state)) {
        seen.add(state);
        out.push(state);
      }
    }
  }
  return out;
}

// Countries that ship with a region breakdown today. Others fall back
// to no region/state pickers (just the Country label).
export const COUNTRIES_WITH_REGIONS = new Set(['NG']);
